import React from "react";
import LayoutSection from "../../layouts/layoutSection";
import TitreSection from "../ui/typographic/titreSection";
import TextSection from "../ui/typographic/textSection";
import { useInView } from "react-intersection-observer";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Guillemet } from "../../svgIcons/guillemet";

const QuotePhoto = ({ lineStep, content, background, dividerColor, pics }) => {

  const { ref, inView } = useInView({
    threshold: 0.25,
    triggerOnce: true
  });

  const Pics = pics.edges
  let res = Pics.filter(pic => pic.node.name === content.photo)

  return (
    <LayoutSection
      id='scroll'
      lineStep={lineStep}
      type='quote'
      extraclass='z-10'
      colorBckgd='bg-white'
      full
    >
      <div ref={ref} className="grid container inherit-container mx-auto min-h-screen md:max-w-full md:grid-cols-12  md:gap-14">
        <div className="col-span-12 md:col-span-8 col-start-1 text-left">
          <TitreSection
            content={content.titre}
            size={5}
            inView={inView}
            reference={ref}
            extraclass=' md:pl-[15%]'
            noMargin
          />
        </div>
        <div className=" hidden md:block md:col-span-4 md:row-start-2 bg-cover bg-no-repeat bg-center ">
          <div className=" flex h-full justify-end items-end">
            <div reference={ref}>
              {
                inView ?
                  <GatsbyImage
                    image={getImage(res[0].node)}
                    alt={content.auteur}
                  />
                  : ''
              }
            </div>
          </div>
        </div>

        <div className="col-span-12 place-self-center relative mt-8 md:mt-0 md:col-span-4 md:col-start-5 md:col-end-12">
          <TextSection
            content={content.description}
            size="m"
            inView={inView}
            reference={ref}
          />
          <div className="text-gray-900 block author bleu text-base font-medium lg:mt-4">
            <span className="leading-3">{content.auteur} - </span>
            <span className=" font-light">{content.position}</span>
          </div>
          <span className="text-5xl absolute -top-8 -left-8 orange z-10" >
            <Guillemet color='#FFE1DB' size={115} />
          </span>
        </div>
      </div>
      {dividerColor ?
        <div className={`hidden absolute -bottom-2 lesep h-14 w-full ${dividerColor} md:block lg:h-20`}></div>
        : ''
      }
    </LayoutSection>
  )
}


export default QuotePhoto
